import { render, staticRenderFns } from "./importMatrix.vue?vue&type=template&id=6f3c711e"
import script from "./importMatrix.vue?vue&type=script&lang=js"
export * from "./importMatrix.vue?vue&type=script&lang=js"
import style0 from "./importMatrix.vue?vue&type=style&index=0&id=6f3c711e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports